module.exports = __webpack_public_path__ + "static/media/login.51e1055c.png";